import {createAction} from 'redux-act';

export const UPLOAD = createAction('uploadFile/UPLOAD');
export const UPLOAD_SUCCESS = createAction('uploadFile/UPLOAD_SUCCESS');
export const DELETE = createAction('uploadFile/DELETE');
